import functions from "../functions";
import { ApiService } from "../ApiService";
export const getDicts = async ({ dic_code, parentValue, parentDicCode }) => {
    if (dic_code) {
        let resp = functions.error;
        await ApiService("gp040099", { dic_code, parentValue, parentDicCode }).then(
            res => {
                resp = res;
            }).catch((err) => {
                resp.message = functions.getInfoRespError(err);
            })
        return resp;
    }
}
/**
 * @param  {string} process_code
 * @param  {object} data
 * @param  {} showLoading
 */
export const send = async (process_code, data, showLoading, unauth) => {
    let resp = functions.error;
    if (showLoading) {
        showLoading(true);
    }
    await ApiService(process_code, data, unauth)
        .then((res) => {
            resp = res;
        })
        .catch((res) => {
            resp.message = res;
        });
    if (showLoading) {
        showLoading(false);
    }
    return resp;
};
